import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IRegisterReducer } from 'core/slices/register';

const register = (state: RootState) => state.register;
const id = (state: RootState, id?: number) => id || state.state[EntityTypes.VERIFICATION_REQUEST];

export const selectVerificationRegister = createSelector([register, id], (register: IRegisterReducer, id: number) => {
  return register.verifications[id];
});
